import { ARCHITECT_CONFIG } from './architect-config';
var ɵ0 = ARCHITECT_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
